import React from "react"

import classes from "./HeldOrderItems.module.scss"

const HeldOrderItems = props => {
  const { heldOrder } = props

  return (
    heldOrder.items.map((orderItem, oiIndex) =>
      <div
        key={oiIndex}
        className={classes["text"]}
      >
        {orderItem.foodName}{" "}
        {orderItem.isSimple ? "" : `(${orderItem.optionName})`}{" "}
        <b>{orderItem.quantity}x</b>
      </div>
    )
  )
}

export default HeldOrderItems